<div class="cellWrapper">
    {{ frequencyTranslationMap[$any(data).schedule.frequency] | translate }}
</div>
